// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';

@Injectable()
export class ElementPosition {

  setElementPosition(
    element: HTMLElement,
    top: number,
    left: number,
    width: number,
    height: number,
  ): void {
    element.style.top = `${ top }px`;
    element.style.left = `${ left }px`;
    element.style.width = `${ width }px`;
    element.style.height = `${ height }px`;
  }
}
